"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.request = exports.setRequestFactory = void 0;
let _factory;
function setRequestFactory(factory) {
    _factory = factory;
}
exports.setRequestFactory = setRequestFactory;
const request = (options) => {
    if (!_factory) {
        throw new Error("需要通过 setRequestFactory 实现 request");
    }
    return _factory(options);
};
exports.request = request;
